(function () {
  if (window.KaleCartDrawerEnhancements) return;

  const requestCart = function () {
    const request = typeof window.cartFetch === 'function' ? window.cartFetch : window.fetch;
    return request.apply(window, arguments);
  };

  const publishCartRefresh = function () {
    if (
      typeof publish === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      return publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fsr-coordinator' });
    }
  };

  const setDiscountError = function (message) {
    const error = document.getElementById('CartDrawer-DiscountError');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  };

  const applyDiscount = async function (event) {
    event.preventDefault();

    const input = document.getElementById('discount_code');
    const button = document.getElementById('apply_discount');
    const discountCode = input?.value.trim();
    if (!discountCode || button?.disabled) return;

    if (button) button.disabled = true;
    setDiscountError('');

    try {
      const cartResponse = await requestCart(window.Shopify.routes.root + 'cart.js');
      if (!cartResponse.ok) throw new Error('Cart request failed (' + cartResponse.status + ')');

      const cart = await cartResponse.json();
      const cart_value = cart.original_total_price;
      const previousCodes = (cart.discount_codes || [])
        .filter((discount) => discount.applicable)
        .map((discount) => discount.code);

      // cart/update.js reports per-code applicability; the /discount/CODE URL
      // used before redirects successfully even for unknown codes.
      const updateDiscounts = async function (codes) {
        const response = await requestCart(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(',') }),
        });
        if (!response.ok) throw new Error('Discount request failed (' + response.status + ')');
        return response.json();
      };

      // Buy-X-get-Y codes only count as applicable once the free product is in the
      // cart, so the gift has to be added before the code is checked.
      const bogoRules = Array.isArray(window.KaleCartDrawerBogoRules) ? window.KaleCartDrawerBogoRules : [];
      const rule = bogoRules.find(
        (candidate) => candidate.code === discountCode.toUpperCase() && cart_value >= candidate.minCents
      );
      const giftAlreadyInCart = rule && (cart.items || []).some((item) => item.variant_id === rule.variantId);
      let addedGiftKey = null;

      if (rule && !giftAlreadyInCart) {
        const addResponse = await requestCart(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items: [{ id: rule.variantId, quantity: 1 }] }),
        });

        if (!addResponse.ok) throw new Error('BOGO add failed (' + addResponse.status + ')');
        addedGiftKey = (await addResponse.json()).items?.[0]?.key || null;
      }

      const updatedCart = await updateDiscounts([discountCode]);
      const applied = (updatedCart.discount_codes || []).some(
        (discount) => discount.applicable && discount.code.toUpperCase() === discountCode.toUpperCase()
      );

      if (!applied) {
        // Take the gift back out so it isn't charged at full price, and restore
        // whatever code worked before so a typo doesn't drop an existing discount.
        if (addedGiftKey) {
          await requestCart(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: addedGiftKey, quantity: 0 }),
          });
        }
        await updateDiscounts(previousCodes);
        await publishCartRefresh();
        setDiscountError('Dieser Rabattcode ist ungültig oder kann auf deinen Warenkorb nicht angewendet werden.');
        return;
      }

      await publishCartRefresh();
    } catch (error) {
      console.error('[Cart drawer discount]', error);
      setDiscountError('Der Rabattcode konnte nicht angewendet werden. Bitte versuche es erneut.');
    } finally {
      if (button) button.disabled = false;
    }
  };

  const updatePrintMaterial = async function (checkbox) {
    const value = checkbox.checked ? 'ja' : '';
    checkbox.disabled = true;

    try {
      const response = await requestCart(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ attributes: { Printmaterial: value } }),
      });

      if (!response.ok) throw new Error('Print-material update failed (' + response.status + ')');
      await publishCartRefresh();
    } catch (error) {
      checkbox.checked = !checkbox.checked;
      checkbox.disabled = false;
      console.error('[Cart drawer print material]', error);
    }
  };

  const removeDiscount = async function (event) {
    event.preventDefault();
    const button = document.getElementById('remove_discount');
    if (!button || button.disabled) return;
    button.disabled = true;
    setDiscountError('');

    try {
      const response = await requestCart(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: '' }),
      });
      if (!response.ok) throw new Error('Discount removal failed (' + response.status + ')');
      await publishCartRefresh();
    } catch (error) {
      button.disabled = false;
      console.error('[Cart drawer discount]', error);
      setDiscountError(window.cartStrings?.error || 'Rabatt konnte nicht entfernt werden.');
    }
  };

  document.addEventListener('click', function (event) {
    if (event.target.closest('#apply_discount')) applyDiscount(event);
    if (event.target.closest('#remove_discount')) removeDiscount(event);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && event.target.id === 'discount_code') applyDiscount(event);
  });

  document.addEventListener('change', function (event) {
    if (event.target.id === 'CartDrawer-PrintMaterial') updatePrintMaterial(event.target);
  });

  window.KaleCartDrawerEnhancements = {
    applyDiscount,
    removeDiscount,
    updatePrintMaterial,
  };
})();
